import { getFields, setLoginStore } from ".";
import { api, apiRoutes } from "../../api";
import { setLocalStorage } from "../../common/helpers";
import { setPopupStore } from "../../components/ErrorPopup";

export const fetchSubmit = async (response?) => {
  setLoginStore({ isLoading: true });
  try {
    const { data } = await api.post(apiRoutes.login, response ?? getFields());
    setLocalStorage("profile", data);
    window.location.replace("/");
  } catch (err: any) {
    setPopupStore({ popupMessage: { message: err.message, type: "error" } });
  } finally {
    setLoginStore({ isLoading: false });
  }
};
